import { Stack, Typography } from '@mui/material';

type Props = {
  label: string;
  values: string[];
};

export default function SectionColorRow({ label, values }: Props) {
  return (
    <div className="section-row">
      <Typography variant="h4">{label}</Typography>
      {values.map((value, index) => (
        <Stack
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          flex={1}
          height="20px"
          borderRadius="100%"
          sx={{
            aspectRatio: '1/1',
          }}
          bgcolor={value}
        />
      ))}
    </div>
  );
}
